<template>
  <div class="empty-list">{{ message }}</div>
</template>

<script>
export default {
  name: "EmptyList",
  props: {
    message: {
      type: String,
      default: "La liste est vide !"
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-list {
  position: absolute;
  left: 47%;
  top: 47%;
  transform: translate(-47%, -47%);
}
</style>
